import React, {useState, useEffect} from 'react'
import axios from 'axios'
import { Row, Col, Typography, message, Pagination, Spin, Button } from 'antd'
import { ShoppingCartOutlined } from '@ant-design/icons'

//Modales
import ModalCompraProductos from '../ModalCompraProductos';

const { Text } = Typography 
const AlmacenProductosList = ({
    inventario_id,
    almacen_id,
    search,
}) => {


    const [loading, setLoading] = useState(false)
    const [productos, setProductos] = useState([])
    const [total, setTotal] = useState(0)
    const [limit, setLimit] = useState(20)
    const [page, setPage] = useState(1)
    const [modalInfo, setModalInfo] = useState({
        visible: false,
        producto_id: undefined,
        producto: undefined,
        cantidad_disp: undefined,
        cantidad_proceso: undefined,
        almacen_id: undefined,
        precio: undefined,
        np_cliente: undefined,
    })

    useEffect(() => {
        getAlmacenProductos()
    }, [inventario_id, almacen_id, search])

    //Obtiene la lista de productos en el almacén
    const getAlmacenProductos = async (page, limit) => {
        setLoading(true)
        try {
            const {data} = await axios.get('/vmi/almacenes-productos', {
                params: {
                    inventario_id,
                    almacen_id,
                    search,
                    limit,
                    page,
                }
            })
            setProductos(data?.data || [])
            setTotal(data?.total || 0)
        } catch (error) {
            console.error('Error fetching almacen productos:', error)
            message.error('Error al obtener los productos del almacén.')
        } finally {
            setLoading(false)
        }
    }

    return (
        <Spin spinning={loading}>
            <Row className="width-100 border-bottom">
                <Col span={8} className="center">
                    <Text>Producto</Text>
                </Col>
                <Col span={4} className="center">
                    <Text className="text-gray">Ubicación</Text>
                </Col>
                <Col span={4} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                    <Text className="text-gray">Cantidad Disponible</Text>
                </Col>
                <Col span={4} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                    <Text className="text-gray">Precio</Text>
                </Col>
                <Col span={4} className="flex-right" style={{ paddingRight: '1.5rem' }}>

                </Col>
            </Row>
            {productos?.map(({ _id, inventario_producto_id, ubicacion, cantidad, cantidad_proceso, producto_id }) => <Row key={_id}>
                <Col span={8} className="center">
                    <Text ellipsis>{inventario_producto_id?.np_cliente}</Text>
                </Col>
                <Col span={4} className="center">
                    <Text className="text-gray">{ubicacion}</Text>
                </Col>
                <Col span={4} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                    <Text className="text-gray">{(cantidad - cantidad_proceso) < 0 ? 0 : (cantidad - cantidad_proceso).toMoney(true)}</Text>
                </Col>
                <Col span={4} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                    <Text className="text-gray">$ {inventario_producto_id?.precio?.toMoney(true)}</Text>
                </Col>
                <Col span={4} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                    
                        <Button
                            disabled={(cantidad - cantidad_proceso) < 1}
                            icon={<ShoppingCartOutlined className="text-white" />}
                            type="primary"
                            className="btn-compra"
                            onClick={() => setModalInfo({
                                visible: true,
                                producto_id: producto_id?._id,
                                producto: producto_id,
                                cantidad_disp: cantidad - cantidad_proceso,
                                cantidad_proceso: cantidad_proceso,
                                cantidad_disp: cantidad,
                                almacen_id: almacen_id,
                                precio: inventario_producto_id?.precio,
                                np_cliente: inventario_producto_id?.np_cliente,
                            })}
                        >
                        </Button>

                    
                </Col>
            </Row>)}
            <Pagination
                className='mt-2 mb-2'
                size='small'
                current={page}
                pageSize={limit}
                total={total}
                onChange={(page, pageSize) => {
                    setPage(page)
                    setLimit(pageSize)
                    getAlmacenProductos(page, pageSize)
                }}
            />
            <ModalCompraProductos
                visible={modalInfo.visible}
                onClose={() => {
                    setModalInfo({
                        visible: false,
                        producto_id: undefined,
                        producto: undefined,
                        cantidad_disp: undefined,
                        almacen_id: undefined,
                        precio: undefined,
                        np_cliente: undefined,
                    })
                    getAlmacenProductos()
                }}
                np_cliente={modalInfo.np_cliente}
                producto={modalInfo.producto}
                cantidad_disp={modalInfo.cantidad_disp}
                cantidad_proceso={modalInfo.cantidad_proceso}
                almacen_id={modalInfo.almacen_id}
                precio={modalInfo.precio}
            />
        </Spin>
    )
}

export default AlmacenProductosList
